import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const habitsAdapter = createEntityAdapter({})

const initialState = habitsAdapter.getInitialState()

export const habitsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHabits: builder.query({
            query: () => ({
                url: '/habits/getHabits',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedHabits = responseData.map(habit => {
                    habit.id = habit._id
                    return habit
                })
                return habitsAdapter.setAll(initialState, loadedHabits)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'Habit', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'Habit', id}))
                    ]
                } else {
                    return [ { type: 'Habit', id: 'LIST'}]
                }
            },
        }),
        createNewHabit: builder.mutation({
            query: initialHabit => ({
                url: '/habits/createNewHabit',
                method: 'POST',
                body: {...initialHabit,}
            }),
            invalidatesTags: [
                { type: 'Habit', id: "LIST" }
            ] 
        }),
        updateHabit: builder.mutation({
            query: initialHabit => ({
                url: '/habits/updateHabit',
                method: 'PATCH',
                body: {...initialHabit,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'Habit', id: arg.id },
                { type: 'Habit', id: 'LIST' }
            ],
        }),
        deleteHabit: builder.mutation({
            query: ({ id }) => ({
              url: '/habits/deleteHabit',
              method: 'DELETE',
              body: { id },  // Send both `habitId` and `userId`
            }),
            invalidatesTags: (result, error, arg) => [
              { type: 'Habit', id: arg.id }
            ],
          }),          
    }),
})

export const {
    useGetHabitsQuery,
    useCreateNewHabitMutation,
    useUpdateHabitMutation,
    useDeleteHabitMutation,
} = habitsApiSlice

// returns the query result object
export const selectHabitResult = habitsApiSlice.endpoints.getHabits.select()

// create memoized selector
const selectHabitsData = createSelector(
    selectHabitResult,
    habitResult => habitResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllHabits,
    selectById: selectHabitById,
    selectIds: selectHabitIds,
} = habitsAdapter.getSelectors(state => selectHabitsData(state) ?? initialState)